import { InfoIcon } from '@chakra-ui/icons'
import { Box, Text } from '@chakra-ui/react'
import React, { PropsWithChildren } from 'react'

export const HistoryNote = ({ children }: PropsWithChildren) => (
  <Box
    w="100%"
    px={2}
    py={1}
    bg="gray.100"
    border="1px solid"
    borderColor="gray.200"
    borderRadius="md">
    <Text w="100%" fontSize="sm" color="gray.700">
      <InfoIcon opacity={0.55} mr={1} w={3.5} h={3.5} position="relative" bottom="2px" />
      <span>{children}</span>
    </Text>
  </Box>
)
